import { render } from "./TransactionDetailItem.vue?vue&type=template&id=599733fa&scoped=true"
import script from "./TransactionDetailItem.vue?vue&type=script&lang=js"
export * from "./TransactionDetailItem.vue?vue&type=script&lang=js"

import "./TransactionDetailItem.vue?vue&type=style&index=0&id=599733fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599733fa"]])

export default __exports__